// extracted by mini-css-extract-plugin
export default {"dots":"TutorialProgress-module__dots--jHcCG","dot":"TutorialProgress-module__dot--uv2vX","active":"TutorialProgress-module__active--kFKLr"};